export default __webpack_public_path__ + "assets/images/469aa201159163ea3ba8795ff5dbf0ca.png";